module.exports = __webpack_public_path__ + "static/img/home.ff3c6eb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/software/app/home.jpg
// module id = oYmN
// module chunks = 0